<template>
  <div class="turnstile-container">
    <div class="d-flex justify-center">
      <div ref="turnstileContainer"></div>
    </div>
    <span v-if="hasError" class="turnstile-subtitle-error">Obrigatório confirmar</span>
  </div>
</template>

<script>
export default {
  name: 'TurnstileWidget',
  props: {
    sitekey: {
      type: String,
      required: true,
    },
    // 'always' | 'execute' | 'interaction-only'
    appearance: {
      type: String,
      default: 'always',
    },
  },
  data() {
    return {
      widgetId: null,
      hasError: false,
      errorCount: 0,
      maxErrorRetries: 3,
      isResetting: false,
    }
  },
  mounted() {
    this.initTurnstile()
  },
  beforeDestroy() {
    if (this.widgetId && window.turnstile) {
      window.turnstile.remove(this.widgetId)
    }
  },
  methods: {
    initTurnstile() {
      if (window.turnstile) {
        this.renderTurnstile()
      } else {
        window.onloadTurnstileCallback = this.renderTurnstile
      }
    },
    renderTurnstile() {
      if (this.$refs.turnstileContainer && window.turnstile) {
        this.widgetId = window.turnstile.render(this.$refs.turnstileContainer, {
          sitekey: this.sitekey,
          appearance: this.appearance,
          callback: this.onVerify,
          'error-callback': this.onError,
          'expired-callback': this.onExpired,
        })
      }
    },
    onVerify(token) {
      this.errorCount = 0
      this.toggleError(false)
      this.$emit('verified', token)
    },
    onError(errorCode) {
      this.errorCount++
      this.$emit('error', errorCode)
      console.error('Turnstile Error:', errorCode)

      if (this.errorCount < this.maxErrorRetries && !this.isResetting) {
        this.isResetting = true
        setTimeout(() => {
          this.reset()
          this.isResetting = false
        }, 1000)
      } else if (this.errorCount >= this.maxErrorRetries) {
        console.error('Turnstile: Maximum reset attempts reached. User interaction required.')
        this.$emit('critical-error', errorCode)
      }
    },
    onExpired() {
      this.$emit('expired')
    },
    reset() {
      if (this.widgetId && window.turnstile && !this.isResetting) {
        window.turnstile.reset(this.widgetId)
        this.toggleError(false)
        this.$emit('reset')
      } else {
        console.warn('Turnstile widget not initialized or Turnstile API not available for reset.')
      }
    },
    focus() {
      document.querySelector('.turnstile-container').focus()
    },
    toggleError(error) {
      this.hasError = error
      if (error) this.focus()
    },
  },
}
</script>

<style lang="scss" scoped>
.turnstile-container {
  width: 100%;
}

.turnstile-subtitle-error {
  width: 100%;
  text-align: center;
  font-weight: 400;
  color: #e03210;
  font-size: 12px;
  display: block;
  margin-top: -2px;
}
</style>
